import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 适配文件
import './utils/_rem.js'

// 全局样式
import "./assets/style/global.less";

Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
